import { FC, useState } from 'react';
import { Alert, Button, Form, Input } from 'antd';
import { Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import {
  RegisterRequest,
  useRegisterMutation,
} from '../../services/AuthService';
import {
  AppPasswordInput,
  getAppPasswordRules,
} from '../shared/AppPasswordInput';
import styles from './style.module.css';

export const { Title } = Typography;

const Register: FC = () => {
  const [register, { isLoading }] = useRegisterMutation();
  const [successMsg, setSuccessMsg] = useState('');
  const [errorMsg, setErrorMsg] = useState('');

  const navigate = useNavigate();

  const handleSubmit = async ({
    userName,
    email,
    password,
  }: RegisterRequest) => {
    try {
      await register({ userName, email: email ?? null, password }).unwrap();

      setSuccessMsg('Успешная регистрация');

      setTimeout(() => {
        navigate('/login');
      }, 2000);
    } catch (err: any) {
      setErrorMsg(err.data);
    }
  };

  return (
    <div className={styles.auth}>
      <Title level={1} className={styles.title}>
        Регистрация
      </Title>
      <Form
        className={styles.formRegister}
        name="login"
        layout="vertical"
        autoComplete="off"
        onFinish={({ userName, email, password }: RegisterRequest) =>
          handleSubmit({ userName, email, password })
        }
        style={{ width: '100%' }}
      >
        <Form.Item
          label="Имя пользователя"
          name="userName"
          rules={[
            { required: true, message: 'Введите имя пользователя' },
            { whitespace: true },
            { min: 3 },
            { max: 20 },
          ]}
          hasFeedback
        >
          <Input onChange={() => setErrorMsg('')} />
        </Form.Item>

        <Form.Item
          label="Почта"
          name="email"
          rules={[
            { required: false, message: 'Введите почту' },
            { type: 'email' },
          ]}
          hasFeedback
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Пароль"
          name="password"
          rules={[
            { required: true, message: 'Введите пароль' },
            ...getAppPasswordRules(),
          ]}
          hasFeedback
        >
          <AppPasswordInput showHint />
        </Form.Item>

        <Form.Item>
          <Button block type="primary" htmlType="submit" loading={isLoading}>
            Зарегистрироваться
          </Button>
        </Form.Item>
      </Form>
      {successMsg && <Alert message={successMsg} type="success" />}
      {errorMsg && <Alert message={errorMsg} type="error" />}
    </div>
  );
};

export default Register;
